import "core-js/modules/es.array.includes.js";
import { VxeRadioGroup } from 'vxe-pc-ui';
import defPropMixin from './defPropMixin';
export default {
  name: 'XRadioGroup',
  components: {
    VxeRadioGroup
  },
  mixins: [defPropMixin],
  props: {
    value: {
      type: [String, Number, String]
    },
    type: {
      type: String,
      default: 'default',
      validator: val => ['default', 'button'].includes(val)
    },
    options: {
      type: Array,
      default: () => []
    },
    optionProps: {
      type: Object,
      default: () => ({
        label: 'label',
        value: 'value',
        disabled: 'disabled'
      })
    },
    strict: {
      type: Boolean,
      default: true
    }
  },
  emits: ['change', 'update:value'],
  setup(props, context) {
    const handleChanged = ({
      value,
      label,
      $event
    }) => {
      context.emit('change', {
        value,
        label,
        $event
      });
      context.emit('update:value', value, $event);
    };
    return {
      handleChanged
    };
  }
};